import useAuthUser from '@forwardflow/hooks/customHooks/useAuthUser'
import AppointmentPreference from '../AppointmentPreference'

const AppointmentPreferencePage = () => {
   const { data: user, isLoading } = useAuthUser({ revalidateOnMount: true })
   if (isLoading) return null
   return (
      <div className="flex flex-col items-center flex-1 min-h-screen px-8 pt-6">
         <div className="w-full">
            <h2 className="mb-2 font-semibold text-white">
               Appointment Preference
            </h2>
            <p className="mb-12 text-sm text-white/70">
               Manage your appointment settings below
            </p>
            <AppointmentPreference email={user?.email || ''} />
         </div>
      </div>
   )
}

export default AppointmentPreferencePage
